import * as React from "react";
import {FC} from "react";

import {Col, Container, Row} from "@pg-design/grid-module";
import {useIsMobile} from "@pg-mono/hooks";

interface IProps {
    children: React.ReactNode;
    className?: string;
    as?: React.ElementType;
}

export const OneColumnGridHolder: FC<IProps> = (props) => {
    return (
        <Container as={props.as} className={props.className}>
            <Row>{props.children}</Row>
        </Container>
    );
};

export const OneColumnGridMain: FC<IProps> = (props) => (
    <Col lgOffset={2} lg={12} className={props.className} as={props.as}>
        {props.children}
    </Col>
);

export const OneColumnGridFullWidth: FC<IProps & {noGutters?: boolean}> = (props) => {
    const isMobile = useIsMobile();

    return (
        <Container fluid={isMobile} as={props.as} className={props.className}>
            <Col lg={16} as="aside" noGutters={props.noGutters}>
                {props.children}
            </Col>
        </Container>
    );
};
import * as React from "react";
import {FC} from "react";

import {Col, Container, Row} from "@pg-design/grid-module";
import {useIsMobile} from "@pg-mono/hooks";

interface IProps {
    children: React.ReactNode;
    className?: string;
    as?: React.ElementType;
}

export const OneColumnGridHolder: FC<IProps> = (props) => {
    return (
        <Container as={props.as} className={props.className}>
            <Row>{props.children}</Row>
        </Container>
    );
};

export const OneColumnGridMain: FC<IProps> = (props) => (
    <Col lgOffset={2} lg={12} className={props.className} as={props.as}>
        {props.children}
    </Col>
);

export const OneColumnGridFullWidth: FC<IProps & {noGutters?: boolean}> = (props) => {
    const isMobile = useIsMobile();

    return (
        <Container fluid={isMobile} as={props.as} className={props.className}>
            <Col lg={16} as="aside" noGutters={props.noGutters}>
                {props.children}
            </Col>
        </Container>
    );
};
